import type { IconProps } from './typesIcons'

export function FaqPlusIcon({
  width = 24,
  height = 24,
  color = '#101010',
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 11.25V4H12.75V11.25H20V12.75H12.75V20H11.25V12.75H4V11.25H11.25Z"
        fill={color}
      />
    </svg>
  )
}
